// This is a file purely for storing variables that are used in multiple files
// This is to avoid circular dependencies
// const API_URL = "http://192.168.1.58:3001/api/v1"
const API_URL = "https://thusund-api.herokuapp.com/api/v1"

export default API_URL;
